import * as React from 'react';

import * as styles from './AppLayout.css';

export const AppLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
